// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    analyzeSalesImgUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1770574295/Generator_featured%20images/webflow-sean/side-kick-tab-image-deals-pipline.avif",
        alt: ""
    },
    analyzeSalesTextAfter: "Analyze sales pipeline",
    analyzeSalesTextBefore: "Analyze sales pipeline",
    buildACompetitorTextAfter: "Build a competitor intelligence tracker",
    buildACompetitorTextBefore: "Build a competitor intelligence tracker",
    competitorIntelligenceImgUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1770574295/Generator_featured%20images/webflow-sean/side-kick-tab-image-competitor.avif",
        alt: ""
    },
    craftEmailImgUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1770574295/Generator_featured%20images/webflow-sean/side-kick-tab-image-leads.avif",
        alt: ""
    },
    craftEmailTextAfter: "Craft email for leads outreach",
    craftEmailTextBefore: "Craft email for leads outreach",
    createProjectTextAfter: "Create a project plan",
    createProjectTextBefore: "Create a project plan",
    createTicketTextAfter: "Create a ticket routing workflow",
    createTicketTextBefore: "Create a ticket routing workflow",
    generateAssetsImgUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1770574295/Generator_featured%20images/webflow-sean/side-kick-tab-image-social-campaign.avif",
        alt: ""
    },
    generateAssetsTextAfter: "Generate assets for social media",
    generateAssetsTextBefore: "Generate assets for social media",
    projectPlanImgUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1770574295/Generator_featured%20images/webflow-sean/side-kick-tab-image-project.avif",
        alt: ""
    },
    researchVenuesImgUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1770574297/Generator_featured%20images/webflow-sean/side-kick-tab-image-event-planning.avif",
        alt: ""
    },
    researchVenuesTextAfter: "Research venues for conference",
    researchVenuesTextBefore: "Research venues for conference",
    ticketRoutingImgUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1770574295/Generator_featured%20images/webflow-sean/side-kick-tab-image-ticket-routing.avif",
        alt: ""
    }
};
